var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"title":'ข้อสอบ / ผู้สอบ',"icon":'book'}})
}
var staticRenderFns = []

export { render, staticRenderFns }